import { BodyM } from '@casavo/base-ui'
import DOMPurify from 'isomorphic-dompurify'
import React from 'react'

import { listingDescriptionClass } from './styles.css'

type Props = {
  safeContent: boolean
  text: string
}

/**
 * A simple text container to allow HTML in listings we know to be safe.
 *
 * Actually, the only HTML we expect from safe content listings are <a/>
 *
 * @param safeContent true if you trust the text to now include malicious content
 * @param text the actual raw text of the description
 * @constructor
 */
export const ListingDescription: React.FC<Props> = ({ safeContent, text }) => {
  if (safeContent) {
    return (
      <BodyM>
        <span className={listingDescriptionClass.safe} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
      </BodyM>
    )
  }

  return (
    <BodyM>
      <span className={listingDescriptionClass.default}>{text}</span>
    </BodyM>
  )
}
